import { render, staticRenderFns } from "./cookies-notice.vue?vue&type=template&id=aa5f4944"
import script from "./cookies-notice.vue?vue&type=script&lang=js"
export * from "./cookies-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports